"use strict";

module.exports = {
  strings: {
    pluginNameOneDrive: 'OneDrive'
  }
};